import React from 'react';
import { CANONICAL_ORIGIN, getAbsoluteUrl, HREFLANG } from '../config/routeMap';

/**
 * <SEOHead routeKey="products" language="fr" title="…" description="…" />
 *
 * Renders <title>, <meta description>, <link rel="canonical">, and 3
 * <link rel="alternate" hreflang="…"> tags using React 19's native
 * head-metadata hoisting.
 *
 * Also emits Open Graph and Twitter Card tags built from the same inputs.
 *
 * Deliberately DOES NOT render <html lang> — that is handled globally by
 * the LanguageContext to avoid conflicts.
 */
const SEOHead = ({ routeKey, language, title, description, image }) => {
  if (!routeKey || !language || !title || !description) return null;

  const canonicalUrl = getAbsoluteUrl(routeKey, language);
  const enUrl = getAbsoluteUrl(routeKey, 'en');
  const frUrl = getAbsoluteUrl(routeKey, 'fr');
  const ogImage = image ? `${CANONICAL_ORIGIN}${image}` : `${CANONICAL_ORIGIN}/images/LOGO_MGP.webp`;

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />

      <link rel="canonical" href={canonicalUrl} />
      <link rel="alternate" hrefLang={HREFLANG.fr} href={frUrl} />
      <link rel="alternate" hrefLang={HREFLANG.en} href={enUrl} />
      <link rel="alternate" hrefLang="x-default" href={enUrl} />

      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content={language === 'fr' ? 'fr_CA' : 'en_US'} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </>
  );
};

export default SEOHead;
